import { render, staticRenderFns } from "./aiBookTask.vue?vue&type=template&id=540ce649&scoped=true&"
import script from "./aiBookTask.vue?vue&type=script&lang=js&"
export * from "./aiBookTask.vue?vue&type=script&lang=js&"
import style0 from "./aiBookTask.vue?vue&type=style&index=0&id=540ce649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540ce649",
  null
  
)

export default component.exports